// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, defineMessages } from 'react-intl';
import { Helmet } from 'react-helmet'
import SignUpForm from './SignUpForm/SignUpForm';

import style from './SignUpPage.scss';

import type { Language } from '../../../../entities/language';
import type { HTTPError } from '../../../../error/index';
import type { LocaleState } from '../../../locale/duck';

type Props = {
  +fbLogin: (country: ?string, language: Language, token: string,
             email?: string, redirectTo?: string) => void;
  +register: (country: ?string, firstName: string, lastName: string,
              email: string, password: string, language: string) => void;
  +logout: () => void;
  +isRegistering: boolean;
  +isAuthing: boolean;
  +signUpError?: HTTPError;
  +authError?: HTTPError;
  +authenticated: boolean;
  +locale: LocaleState;
  +registerSuccessState?: boolean;
};

const messages = defineMessages({
  title: {
    id: 'signup.document.title',
  },
  description: {
    id: 'signup.document.description',
  },
});

export default class SignUpPage extends Component<Props, void> {
  redirectTo = '/';

  render() {
    const {
      register, isRegistering, signUpError, fbLogin,
      logout, isAuthing, authError, authenticated, locale, registerSuccessState,
    } = this.props;
    return [
      <Helmet key="helmet">
        <title>{this.context.intl.formatMessage(messages.title)}</title>
        <meta name="description" content={this.context.intl.formatMessage(messages.description)}/>
      </Helmet>,
      <section key="loginPageWrap" className={style.signUpPageWrap}>
        <article className={style.signUpWrap}>
          <SignUpForm register={register}
                      isRegistering={isRegistering}
                      signUpError={signUpError}
                      fbLogin={fbLogin}
                      logout={logout}
                      isAuthing={isAuthing}
                      authError={authError}
                      authenticated={authenticated}
                      locale={locale}
                      registerSuccessState={registerSuccessState}
                      redirectTo={this.redirectTo}/>
        </article>
      </section>
    ];
  }
};

SignUpPage.propTypes = {
  fbLogin: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  isAuthing: PropTypes.bool,
  isRegistering: PropTypes.bool,
  signUpError: PropTypes.object,
  authError: PropTypes.object,
  authenticated: PropTypes.bool,
  locale: PropTypes.object,
  registerSuccessState: PropTypes.bool,
};

SignUpPage.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/auth/components/SignUp/SignUpPage.jsx